import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorLogService } from './error-log.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalerrorhandlerService implements ErrorHandler {

  constructor(
    private errorLogService: ErrorLogService
  ) { }

  handleError(error: any): void {
    if(this.errorLogService) {
      this.errorLogService.logError(error);
    }
  }
}
